module.exports = __webpack_public_path__ + "img/calendar.c5c0344.jpg";